export const initialMemberState: IMemberState = {
  selectedSubscriber: {},
  addMemberFeed: {
    planAcronym: '',
    clientId: '',
    subClientId: '',
    asOf: ''
  },
  selectedDependent: {},
  dependentAdded: false
};

export interface IMemberState {
  selectedSubscriber: {};
  addMemberFeed: {
    subscriberName?: string;
    planAcronym: string | string [];
    clientId: string;
    subClientId: string;
    memberId?: number;
    pseudoSsnInd?: boolean;
    subscriberEnrollmentID?: number;
    foundMember?: any;
    asOf: string;
    eligibilityEffectiveDate?: any;
    receivedDate?: any;
    qualifierType?: any;
    memberBenefitType?: any;
    eligibilityStatusReason?: string;
    eligibilityStatus?: string;
  };
  selectedDependent: {};
  dependentAdded: boolean;
}
